
      <!-- bradcam_area  -->
      <div class="bradcam_area bradcam_bg_2" id="goToTop">
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="bradcam_text">
                        <h3 i18n>Politique de confidentialité</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--/ bradcam_area  -->

    <!-- privacy_area_start  -->
    <div class="about_area plus_padding pp-area">
        <div class="container">

            <div class="row justify-content-center">
                <div class="col-xl-9 col-lg-10">

                    <p class="pp-effective">{{ view.effectiveDate }}</p>
                    <p class="pp-intro">{{ view.intro }}</p>

                    <div class="pp-card" *ngFor="let s of view.sections">
                        <div class="pp-card__head">
                            <span class="pp-icon">{{ iconEmoji(s.icon) }}</span>
                            <h4 class="pp-card__title">{{ s.title }}</h4>
                        </div>
                        <p class="pp-card__body">{{ s.body }}</p>
                    </div>

                    <div class="pp-card pp-card--contact">
                        <div class="pp-card__head">
                            <span class="pp-icon">✉️</span>
                            <h4 class="pp-card__title">{{ view.contactTitle }}</h4>
                        </div>
                        <p class="pp-card__body">{{ view.contactBody }}</p>
                        <a class="pp-contact-btn" href="mailto:{{ view.contactEmail }}"
                           *ngIf="view.contactEmail">
                            {{ view.contactEmail }}
                        </a>
                    </div>

                    <p class="pp-updated">{{ view.lastUpdated }}</p>

                </div>
            </div>
        </div>
    </div>
    <!--/ privacy_area  -->
